import { Modules } from '@estercare/ester-shared'

// Default fallback image
export const DEFAULT_MODULE_IMAGE = '/images/stock1.png'

export const MODULE_IMAGE_IDS: Record<Modules, string> = {
  [Modules.Om]: '44cpChYYfXiAe3joIAiMpM',
  [Modules.Kost]: '2KJ8wybZHkjVa5zBGwOsoW',
  [Modules.Traning]: '4rQVjoGTYXcAH8anhMNktA',
  [Modules.Stresshantering]: '1eeHKyUk2FhSO4eeVByiqO',
  [Modules.Psykiskt_valmaende]: '1xFC4nOhnaCQWylMprrZGM',
  [Modules.Somn]: '44tRF8JDwD2GpoozgXa0xF',
  [Modules.Egenvard]: '74j4JN2zfl5J8KY5apfEea',
  [Modules.Livsstil]: '4QEaGWdWmZrE3gkbXm9JwB',
  [Modules.Uppfoljning]: '18lqWpLzVorJ2lQ1TFRKgS',
}

export const getModuleImageId = (moduleId: Modules): string => {
  return MODULE_IMAGE_IDS[moduleId]
}

// Map HealthCardModule (English enum) to Contentful asset IDs
export const HEALTH_CARD_MODULE_IMAGE_IDS: Record<string, string> = {
  NUTRITION: '2KJ8wybZHkjVa5zBGwOsoW',
  EXERCISE: '4rQVjoGTYXcAH8anhMNktA',
  STRESS_MANAGEMENT: '1eeHKyUk2FhSO4eeVByiqO',
  MENTAL_WELLBEING: '1xFC4nOhnaCQWylMprrZGM',
  SLEEP: '44tRF8JDwD2GpoozgXa0xF',
  OVER_THE_COUNTER_CARE: '74j4JN2zfl5J8KY5apfEea',
  LIFESTYLE: '4QEaGWdWmZrE3gkbXm9JwB',
  CARE_PLAN: '41s1Pf71OzrBqmYq0Dzz2w',
}

export const DEFAULT_HEALTH_CARD_IMAGE_ID = '44cpChYYfXiAe3joIAiMpM'

export const getHealthCardModuleImageId = (module: string): string => {
  return HEALTH_CARD_MODULE_IMAGE_IDS[module] || DEFAULT_HEALTH_CARD_IMAGE_ID
}
